module.exports = __webpack_public_path__ + "img/xt4@2x.bc3b8c6d.png";